import React from "react";

export const STATUSES = ["New", "Contacted", "Scheduled", "Completed", "Cancelled"];

const COLORS = {
  New: "bg-blue-100 text-blue-700 border-blue-200",
  Contacted: "bg-amber-100 text-amber-700 border-amber-200",
  Scheduled: "bg-purple-100 text-purple-700 border-purple-200",
  Completed: "bg-green-100 text-green-700 border-green-200",
  Cancelled: "bg-rose-100 text-rose-700 border-rose-200",
};

export function StatusBadge({ status }) {
  return (
    <span className={`inline-flex rounded-full border px-3 py-1 text-xs font-semibold ${COLORS[status] || "bg-gray-100 text-gray-600 border-gray-200"}`}>
      {status}
    </span>
  );
}

export function StatCard({ label, value, tone = "default", icon: Icon }) {
  const tones = {
    default: "border-soft-border bg-cream",
    terracotta: "border-terracotta/20 bg-terracotta text-cream",
  };
  return (
    <div className={`rounded-2xl border p-6 ${tones[tone]}`}>
      <div className="flex items-start justify-between">
        <div>
          <p className={`text-3xl font-serif ${tone === "terracotta" ? "text-cream" : "text-charcoal"}`}>{value}</p>
          <p className={`mt-1 text-xs font-medium uppercase tracking-wide ${tone === "terracotta" ? "text-cream/80" : "text-taupe"}`}>{label}</p>
        </div>
        {Icon && <Icon className={`h-5 w-5 ${tone === "terracotta" ? "text-cream/70" : "text-terracotta"}`} />}
      </div>
    </div>
  );
}

export function fmtDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
  } catch { return iso; }
}
